import { useMutation } from "@tanstack/react-query";
import { useEffect } from "react";

import { enterFulfillmentWorkspace } from "../repo";

/** 按 URL 中课程线路 ID 幂等进入唯一确认件工作区。 */
export function useFulfillmentOrderEntryRedirect(itineraryId: string | undefined) {
  const mutation = useMutation({
    mutationFn: () => enterFulfillmentWorkspace(itineraryId as string),
    retry: false,
  });

  useEffect(() => {
    if (itineraryId) {
      mutation.mutate();
    }
  }, [itineraryId, mutation.mutate]);

  return {
    ...mutation,
    refetch: mutation.mutate,
  };
}
